import { Injectable, NgZone, inject } from '@angular/core';

import { ExternalService } from 'src/app/core/models/core.models';
import { LoggerService } from './logger.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ExternalAuthService {
  private callbacks = new Map<ExternalService, (responseData: any) => void>();
  private logger = inject(LoggerService);
  constructor(private ngZone: NgZone) {}

  /**
   * Register a custom callback for a specific external service.
   */
  registerCallback(
    service: ExternalService,
    callback: (responseData: any) => void,
  ): void {
    this.callbacks.set(service, callback);

    if (service === ExternalService.FACEBOOK) {
      (window as any).facebookAuthResponseData = (data: any) => {
        this.ngZone.run(() => {
          const cb = this.callbacks.get(service);
          if (cb) {
            //console.log('OAuth Response received in Facebook Callback: ', data);
            this.logger.debug(
              'OAuth Response received in Facebook Callback: ',
              data,
            );
            cb(data);
          } else {
            this.logger.debug('OAuth Response received in Facebook is empty');
          }
        });
      };
    }

    if (
      service === ExternalService.MATTERMOST_MOE ||
      service === ExternalService.MATTERMOST_TEST ||
      service === ExternalService.MATTERMOST_MOE_PROD
    ) {
      (window as any).oauthCodeAuthResponseData = (data: any) => {
        this.ngZone.run(() => {
          const cb = this.callbacks.get(service);
          if (cb) {
            //console.log('OAuth Response received in Mattermost Callback: ', data);
            this.logger.debug(
              'OAuth Response received in Mattermost Callback: ',
              data,
            );
            cb(data);
          } else {
            this.logger.debug('OAuth Response received in Mattermost is empty');
          }
        });
      };
    }
  }

  /**
   * Opens the OAuth authentication popup.
   */

  authenticate(service: ExternalService, userId?: string | null): void {
    const width = 800;
    const height = 700;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    const windowName = 'ConnectWithOAuth';
    const windowOptions = `titlebar=0,menubar=0,status=0,toolbar=0,location=0,width=${width},height=${height},left=${left},top=${top}`;
    const userIdParam = userId ? `?userId=${encodeURIComponent(userId)}` : '';
    const authUrl = `${environment.baseUrl}/oauth/${service}/authorize${userIdParam}`;
    const popup = window.open(authUrl, windowName, windowOptions);

    if (!popup) {
      this.logger.debug('OAuth popup was blocked by the browser');
    }
  }
}
